import { useRouter, type Href, type NativeStackHeaderItem } from 'expo-router'
import { useMemo } from 'react'
import { Platform } from 'react-native'

export default function useWebBackButton(defaultBackHref?: Href): NativeStackHeaderItem[] | undefined {
  const router = useRouter()

  return useMemo(() => {
    if (Platform.OS !== 'web' || !defaultBackHref) return undefined
    const canGoBack = router.canGoBack()
    return [
      {
        type: 'button' as const,
        label: '返回',
        icon: { name: 'chevron.left' as const, type: 'sfSymbol' as const },
        onPress: () => (canGoBack ? router.back() : router.replace(defaultBackHref)),
      },
    ]
  }, [defaultBackHref, router])
}
